import React from 'react';
import { AppBar } from './AppBar';
import { BottomNav } from './BottomNav';
import { StickyDock } from './StickyDock';
import type { AppBarProps } from './AppBar';
import type { BottomNavProps } from './BottomNav';
import type { StickyDockProps } from './StickyDock';

export interface PageProps {
  children: React.ReactNode;
  appBar?: AppBarProps | false;
  bottomNav?: BottomNavProps | false;
  stickyDock?: StickyDockProps | false;
  className?: string;
  hasSafeBottom?: boolean;
}

export const Page: React.FC<PageProps> = ({
  children,
  appBar,
  bottomNav,
  stickyDock,
  className = '',
  hasSafeBottom = true,
}) => {
  return (
    <div className={`page ${hasSafeBottom ? 'pb-safe' : ''} ${className}`}>
      {appBar !== false && appBar && <AppBar {...appBar} />}
      <main className="container page-content">
        {children}
      </main>
      {stickyDock !== false && stickyDock && <StickyDock {...stickyDock} />}
      {bottomNav !== false && bottomNav && <BottomNav {...bottomNav} />}
    </div>
  );
};

export interface SimplePageProps {
  children: React.ReactNode;
  className?: string;
  paddingTop?: boolean;
  paddingBottom?: boolean;
}

export const SimplePage: React.FC<SimplePageProps> = ({
  children,
  className = '',
  paddingTop = true,
  paddingBottom = true,
}) => {
  return (
    <div
      className={`
        min-h-screen
        ${paddingTop ? 'pt-16' : ''}
        ${paddingBottom ? 'pb-16' : ''}
        px-4
        ${className}
      `}
    >
      <div className="container">
        {children}
      </div>
    </div>
  );
};